import { binance, injected, useWalletConnect, useWalletLink } from 'app-lib/web3ReactUtils'
import { AbstractConnector } from '@web3-react/abstract-connector'
import { ReactComponent as BinanceLogoShort } from '../assets/images/providers/logo_short___binance.svg'
import { ReactComponent as WalletLinkLogoShort } from '../assets/images/providers/logo_short___coinbase.svg'
import { ReactComponent as GenericWalletShort } from '../assets/images/providers/logo_short___genericwallet.svg'
import { ReactComponent as MetamaskLogoShort } from '../assets/images/providers/logo_short___metamask.svg'
import { ReactComponent as TrustWalletLogoShort } from '../assets/images/providers/logo_short___trustwallet.svg'
import { ReactComponent as WalletConnectLogoShort } from '../assets/images/providers/logo_short___walletconnect.svg'
import { ChainId } from '../config/chains/chainCommon'

export enum ProviderType {
  MetaMask = 'MetaMask',
  TrustWallet = 'TrustWallet',
  Binance = 'Binance',
  WalletConnect = 'WalletConnect',
  WalletLink = 'WalletLink', // Coinbase
  None = 'None',
}

const connectorsByType: Partial<Record<ProviderType, AbstractConnector | null>> = {
  [ProviderType.MetaMask]: injected,
  [ProviderType.TrustWallet]: injected,
  [ProviderType.Binance]: binance,
  [ProviderType.None]: null,
}

export interface IProviderDetails {
  label: string
  ProviderLogo: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string
    }
  >
}

export const providersDetails: Record<ProviderType, IProviderDetails> = {
  [ProviderType.MetaMask]: { label: 'MetaMask', ProviderLogo: MetamaskLogoShort },
  [ProviderType.TrustWallet]: { label: 'TrustWallet', ProviderLogo: TrustWalletLogoShort },
  [ProviderType.TrustWallet]: { label: 'TrustWallet', ProviderLogo: TrustWalletLogoShort },
  [ProviderType.WalletConnect]: { label: 'WalletConnect', ProviderLogo: WalletConnectLogoShort },
  [ProviderType.WalletLink]: { label: 'WalletLink', ProviderLogo: WalletLinkLogoShort },
  [ProviderType.Binance]: { label: 'Binance Wallet', ProviderLogo: BinanceLogoShort },
  [ProviderType.None]: { label: 'None', ProviderLogo: GenericWalletShort },
}

export async function getProviderTypeByConnector(value: AbstractConnector): Promise<ProviderType> {
  const provider = await value.getProvider()
  if (value === injected) {
    return provider.isMetaMask ? ProviderType.MetaMask : ProviderType.TrustWallet
  }
  if (provider.isWalletConnect) {
    return ProviderType.WalletConnect
  }
  if (provider.isWalletLink) {
    return ProviderType.WalletLink
  }
  return Object.keys(connectorsByType).find(
    (key) => connectorsByType[key as ProviderType] === value
  ) as ProviderType
}

export function getConnectorByProviderType(
  providerType: ProviderType,
  chainId?: ChainId
): AbstractConnector | null {
  if (providerType === ProviderType.WalletConnect && chainId) {
    return useWalletConnect(chainId)
  }
  if (providerType === ProviderType.WalletLink && chainId) {
    return useWalletLink(chainId)
  }
  return connectorsByType[providerType] || null
}
